import { Injectable } from '@angular/core';
import { environment } from './../environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class UtilisService {

  private BASE_URL: string;
  decPassword = "`?.F(fHbN6XK|j!t";
  private data: any = {};
  private isReloadedAfterLogin: boolean = true;
  constructor() {
    this.BASE_URL = environment.baseURL;
  }

  getBasePath() {
    return this.BASE_URL;
  }
  getData() {
    return this.data;
  }

  setData(data) {
    this.data = data;
  }

  setIsReloadedAfterLogin(value: boolean) {
    this.isReloadedAfterLogin = value;
  }

  getIsReloadedAfterLogin() {
    return this.isReloadedAfterLogin;
  }
  Decryptdata(encryptText){
    return CryptoJS.AES.decrypt(encryptText.trim(), this.decPassword.trim()).toString(CryptoJS.enc.Utf8);
  }
  Encryptdata(plainText){
    return CryptoJS.AES.encrypt(plainText.trim(), this.decPassword.trim()).toString();
  }

  DecryptdataV1(encryptText,encKey){
    return CryptoJS.AES.decrypt(encryptText.trim(), encKey.trim()).toString(CryptoJS.enc.Utf8);
  }
  EncryptdataV1(plainText,encKey){
    return CryptoJS.AES.encrypt(plainText.trim(), encKey.trim()).toString();
  }
}